// sandboxFormatters.js — the pure helpers a generated app may el.call
// (APP_EL_CALL_ALLOWLIST, besides polyglot): ONE source for the shell (which
// re-exports them from functions/index.js) and the sandbox frame (whose
// bootstrap receives them as text — sandboxFrameBoot.js). Each function is
// SELF-CONTAINED: no module-scope name, only frame-realm globals (Date,
// String, Number), so its .toString() runs the same in the opaque frame.
// toLocale*String reuses the engine's own formatter cache, so no module
// cache is needed. __tests__/sandboxFormatters.test.js holds them: outputs,
// one source, free names, and the frame registry.

// formatTime and formatMonthShort keep the exact semantics of the
// Intl.DateTimeFormat#format they replaced: `undefined` is now, any other
// value goes through Number() (a date STRING is NaN), and NaN throws
// RangeError — measured equal over a 2,863-row grid of inputs and zones.

// Clock time, "1:07pm" (en-US, 12-hour, lower case, no space); an unknown
// time zone falls back to the local zone.
const formatTime = (ts, tz) => {
  if (!ts) return ''
  const t = Number(ts)
  if (Number.isNaN(t)) throw new RangeError('Invalid time value')
  try {
    return new Date(t)
      .toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: tz,
        hour12: true
      })
      .toLowerCase()
      .replace(' ', '')
  } catch {
    return new Date(t).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }
}

// Short month name, "Oct".
const formatMonthShort = (ts) => {
  const t = ts === undefined ? Date.now() : Number(ts)
  if (Number.isNaN(t)) throw new RangeError('Invalid time value')
  return new Date(t).toLocaleDateString('en', { month: 'short' })
}

// Compact numeric date for data-dense rows, "22.06.2022" (dotted so it reads
// as data next to a Code-mono amount or time).
const formatShortDate = (ts) => {
  if (!ts) return ''
  try {
    const d = new Date(ts)
    if (Number.isNaN(d.getTime())) return ''
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    return `${dd}.${mm}.${d.getFullYear()}`
  } catch {
    return ''
  }
}

export const SANDBOX_FORMATTERS = Object.freeze({ formatShortDate, formatMonthShort, formatTime })
export { formatShortDate, formatMonthShort, formatTime }
